import { map } from 'lodash/fp';
import { Field } from 'redux-form';
import { RadioButton, RadioGroup } from '@optimus-web/core';
import { getError } from '../../utils';

const renderRadioOptions = map(({ value, ...other }) => (
    <RadioButton key={value} value={value} {...other} size="small" />
));

interface RadioGroupFieldRendererProps {
    input?: $TSFixMe; // TODO: pt.shape(fieldInputPropTypes) from redux-form
    meta?: $TSFixMe; // TODO: pt.shape(fieldMetaPropTypes from redux-form)
}

// @ts-expect-error $TSFixMeError: Property 'options' does not exist on type 'RadioGroupFieldRendererProps'.
const RadioGroupFieldRenderer = ({ input, options, meta, ...other }: RadioGroupFieldRendererProps) => (
    <RadioGroup error={getError(meta)} {...input} {...other}>
        {renderRadioOptions(options)}
    </RadioGroup>
);

const RadioGroupField = (props: $TSFixMe) => <Field component={RadioGroupFieldRenderer} {...props} />;

export default RadioGroupField;
